import * as React from 'react';

import classNames from 'classnames';

import { color } from '@coursera/coursera-ui';
import { SvgCheckSolid } from '@coursera/coursera-ui/svg';

import { ACTIVE, DISABLED, DONE } from 'bundles/teams-v2/constants/progressStatus';

import 'css!./__styles__/TeamsCheckoutProgressIcon';

export type statusType = 'DONE' | 'ACTIVE' | 'DISABLED';
type Props = {
  label: string;
  status: statusType;
};

const TeamsCheckoutProgressIcon = ({ label, status }: Props) => (
  <div className="rc-TeamsCheckoutProgressIcon vertical-box align-items-vertical-center">
    {status === DONE ? (
      <SvgCheckSolid color={color.primary} size={28} />
    ) : (
      <div className={classNames('c-TeamsProgressCircle m-a-0', { greyedOut: status === DISABLED })} />
    )}
    <label className={classNames('c-TeamsProgressLabel', { active: status === ACTIVE })} htmlFor="checkout progress">
      {label}
    </label>
  </div>
);

export default TeamsCheckoutProgressIcon;
